"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

const jsx_runtime_1 = require("react/jsx-runtime");

const SvgImage = props => (0, jsx_runtime_1.jsxs)("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props, {
  children: [(0, jsx_runtime_1.jsx)("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }, void 0), (0, jsx_runtime_1.jsx)("g", Object.assign({
    "data-name": "Group 556"
  }, {
    children: (0, jsx_runtime_1.jsx)("path", {
      "data-name": "Union 3",
      d: "M3.997 22a2 2 0 01-2-2V4a2 2 0 012-2h16a2 2 0 012 2v16a1.977 1.977 0 01-.43 1.223 1.976 1.976 0 01-1.344.753 1.829 1.829 0 01-.227.023zM8.06 10.334l-4.562 4.562v5.105a.5.5 0 00.5.5h14.938L8.769 10.334a.5.5 0 00-.354-.146.5.5 0 00-.352.145zm1.768-1.062l10.668 10.671V4a.5.5 0 00-.5-.5h-16a.5.5 0 00-.5.5v8.775l3.5-3.5a1.989 1.989 0 011.413-.586 1.994 1.994 0 011.422.583zm5.169-1.522a1.251 1.251 0 011.251-1.25 1.251 1.251 0 011.25 1.25A1.249 1.249 0 0116.248 9a1.249 1.249 0 01-1.251-1.25z",
      fill: "#2d5dec"
    }, void 0)
  }), void 0)]
}), void 0);

exports.default = SvgImage;